var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.videocallsCount > 0)?_c('span',{staticClass:"notification-badge position-absolute top-0 start-100 translate-middle badge rounded-pill",class:_vm.animateClass},[_vm._v("\n        "+_vm._s(_vm.videocallsCount)+"\n        "),_c('span',{staticClass:"visually-hidden"},[_vm._v(_vm._s(_vm.unconfirmedvideocallslabel))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }